import { IAdminFlight } from '../eventFlights/store';
import { IEventRound } from '../eventRounds/store';
// TODO: move to club store
export interface IClubSeason {
  club: number;
  end: string;
  id: number;
  start: string;
  year: string;
}

export interface IPrice {
  ageFrom: number | null;
  ageTo: number | null;
  end: string;
  event: number;
  id?: number;
  name: string;
  price: number;
  start: string;
}

export interface IAddon {
  event: number;
  id?: number;
  name: string;
  price: number;
}

export interface ICoupon {
  active: boolean;
  codename: string;
  description: string;
  discountValue: number;
  event: number;
  id?: number;
  quantity: number;
  title: string;
}

export type AdminEventStatusType = 'draft' | 'published' | 'completed';

export enum HANDICAP_METRIC {
  'CURRENT_GHIN',
  'LOWEST_GHIN',
  'CLUB_INDEX_OR_GHIN',
  'CLUB_INDEX',
  'MANUAL'
}

export interface IAdminEvent {
  addons: IAddon[];
  allowScramble: boolean;
  allowTeams: boolean;
  automaticHandicaps: boolean;
  club: number;
  courses: string;
  coupons: ICoupon[];
  description?: string;
  end: string;
  flights: IAdminFlight[];
  flightsByAge: boolean;
  flightsByGender: boolean;
  flightsByHandicap: boolean;
  flightsMetric: number;
  handicapAdjustment: number;
  handicapMetric: HANDICAP_METRIC;
  id: number;
  image: string;
  name: string;
  playersPerTeam: number | null;
  prices: IPrice[];
  processPayment: boolean;
  rounds: IEventRound[];
  season: IClubSeason;
  start: string;
  status: AdminEventStatusType;
  totalActiveEnrollments: number;
  totalPlayers: number;
  totalRounds: number;
  useFlights: boolean;
  verboseStatus: string;
}

export const initialEventTemplate: Partial<IAdminEvent> = {
  end: '',
  name: '',
  start: ''
};

export interface IAdminEventsStore {
  all: {
    [key: number]: IAdminEvent;
  };
  current?: IAdminEvent;
  [key: number]: IAdminEvent;
}

export const adminEventsStore: IAdminEventsStore = {
  all: {}
};
